export default {
      path: '/lvy-synopsis',
      component: () => import('./LVYSynopsis'),
      meta: {
        title: '青藤之恋介绍',
        designWidth:750,
        expireIn: '',
        axiosConfig: {
          baseURL: '',
          withCredentials: false,
          postContentType: 'JSON'
        }
      }
    }
